<template>
	<div v-if="user">
		<router-view
			v-if="user.hasRole(['manager', 'admin', 'staff'])"
			:user="user"
			:isAuth="isAuth">
		</router-view>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productCategories/layout/ProductCategories.vue